module.exports = __webpack_public_path__ + "../resources/img/ic-re-plus-default.5a58082d.svg";